<template>
  <h1>Dashboard</h1>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      title: 'Dashboard',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
};
</script>

<style scoped></style>
